import { apiConfig } from '../api-config';

export const getPix = async (txId: string) => {
  return apiConfig
    .get(`/api/Payment/get-pix?txid=${txId}`)
    .then((resp) => resp.data.objectResult || [])
    .catch((err) => ({ hasErrors: true, err }));
};
